import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const WachtGoedkeuringScreen = () => {


  return (
    <div className='container'>
    <div className='input-container'>
        <img
            className=""
            src="/img/logo.png"
            alt="Logo"
        />
        <h1>Registratie Ingediend</h1>
        <p>Je account is nog niet goedgekeurd. Je zult worden geïnformeerd zodra je registratie is goedgekeurd.</p>
    </div>
        <Link className="registerlink" to="/login">Al een account? Log in.</Link>
    </div>
  );
};

export default WachtGoedkeuringScreen;
